import PageHeader from './PageHeader.jsx';

// Placeholder used by the dashboard sections that v0 does not implement
// end-to-end. Each lists what *will* live here so the surface is honest.
export default function StubPage({ title, description, planned }) {
  return (
    <>
      <PageHeader
        title={title}
        description={description}
        actions={
          <span className="rounded-full border border-amber-300 bg-amber-50 px-3 py-1 text-xs font-semibold text-amber-700">
            Coming soon
          </span>
        }
      />
      <div className="px-8 py-8">
        <div className="card max-w-3xl p-6">
          <h2 className="text-base font-semibold">Planned in this section</h2>
          <ul className="mt-3 space-y-2 text-sm text-ink-600 dark:text-ink-300">
            {planned.map((p) => (
              <li key={p} className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-brand-500" />
                <span>{p}</span>
              </li>
            ))}
          </ul>
          <p className="mt-5 text-xs text-ink-500">
            v0 ships the data model + dashboard surface for these. Wire-up to UIs and external
            providers comes next.
          </p>
        </div>
      </div>
    </>
  );
}
